module.exports = __webpack_public_path__ + "img/Logo.fff70d2f.png";